import React from 'react'
import Header from '../Components/Header/Header'
import Cart from '../Components/Cart/Cart'
function CartAndSummary() {
  return (
    <div>
        <Header></Header>
        <Cart></Cart>
    </div>
    
  )
}

export default CartAndSummary